/* Size XCloud's instant-search panel to the search bar in use (4 Sept 2026).
   XCloud positions #cloud-search-results itself but hard-codes a 550px
   width; assets/xcloud-instant-search.css reads the two custom properties
   set here. Runs only when settings.xcloud_instant_search is on. */
(function () {
  var root = document.documentElement;

  function activeForm() {
    var el = document.activeElement;
    if (el && el.name === 'q' && el.form) return el.form;
    return document.querySelector('form.header__search-form') ||
      document.querySelector('[data-autocomplete-true] form');
  }

  function sync() {
    var form = activeForm();
    if (!form) return;
    var r = form.getBoundingClientRect();
    if (r.width > 0) {
      root.style.setProperty('--gv-xcloud-menu-width', Math.round(r.width) + 'px');
      root.style.setProperty('--gv-xcloud-menu-top', Math.round(r.bottom) + 'px');
    }
  }

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.name === 'q') sync();
  });
  window.addEventListener('resize', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
